import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { qk } from '@/src/shared/api/queryKeys';
import { axiosInstance as api } from '@/src/shared/lib/axios';
import type {CompetitionDto, CompetitionListDto} from './types';

export type CompetitionPeriod = 'active' | 'past';

export function useCompetitionList(period: CompetitionPeriod = 'active', page = 1) {
    return useQuery({
        queryKey: qk.competitions(period, page),
        queryFn: async (): Promise<CompetitionListDto> => {
            const endpoint = period === 'past'
                ? 'system/v1/competition/past/'
                : 'system/v1/competition/';
            const { data } = await api.get<CompetitionListDto>(endpoint, {params: {page}});
            return data;
        },
        staleTime: 60_000,
    });
}

// Соревнование адресуется и числовым id, и слагом — бэкенд принимает оба варианта
export function useCompetition(competitionKey: number | string) {
    return useQuery({
        queryKey: qk.competition(competitionKey),
        queryFn: async (): Promise<CompetitionDto> => {
            const { data } = await api.get<CompetitionDto>(`system/v1/competition/${competitionKey}`);
            return data
        },
        enabled: Boolean(competitionKey),
        retry: (failureCount, error) => {
            // Несуществующий слаг не имеет смысла перезапрашивать — страница покажет 404
            if (isAxiosError(error) && error.response?.status === 404) return false;
            return failureCount < 3;
        },
    })
}